import React from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Menu, MenuItem, Fade, ListItemText, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormMode } from '../utils/extensions/constantEx'
import VisibilityIcon from '@mui/icons-material/Visibility';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const EmployeeMenuPopup = (props) => {
    const { dbEmployeeRow, handleDeleteClick } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleEditClick = () => {
        handleMoreClose();
        navigate("/employee-form", {
            replace: false,
            state: {
                formMode: FormMode.ViewMode,
                from: 'search-employees',
                selectedId: dbEmployeeRow.id
            }
        });
    }

    const handleMenuDeleteClick = () => {
        handleMoreClose();
        handleDeleteClick(dbEmployeeRow.id);
    }

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMoreClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton onClick={handleMoreClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMoreClose}
                slotProps={{
                    transition: Fade
                }}
            >
                <MenuItem onClick={handleEditClick} disableRipple>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View</ListItemText>
                </MenuItem>
                {/* <MenuItem onClick={handleMenuDeleteClick} disableRipple>
                    <ListItemIcon>
                        <RemoveCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem> */}
            </Menu>

        </Box>

    );
}
export default EmployeeMenuPopup;